import React from 'react'
import {ConfirmContent} from '../../../Molecules/BaseContentBlocks/ConfirmContent'
import {formatPostCode} from '../../../../../Common/Components/PostCodeInformation'
import {ADDRESS} from '../../../../../Common/Constants'
import {ShippingOnlyAddress} from '../../../../DTO/MemberShippingAddressDTO'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'

export const ShippingAddressConfirms: React.VFC<ShippingOnlyAddress> = (
  {
    postCode,
    addressPrefectureCode,
    addressCity,
    addressStreet,
    addressBuilding,
  },
) => {
  return (
    <PIMStack
      spacing={'18px'}
      divider={<MBContentBodyDivider/>}
    >
      <ConfirmContent
        label={'郵便番号'} values={[formatPostCode(postCode) || '']}
        testDataId={'confirm-content-post-code'}
      />
      <ConfirmContent
        label={'都道府県'} values={[ADDRESS.PREFECTURES[addressPrefectureCode]]}
        testDataId={'confirm-content-address-prefecture'}
      />
      <ConfirmContent
        label={'市区町村'} values={[addressCity]}
        testDataId={'confirm-content-address-city'}
      />
      <ConfirmContent
        label={'以降の住所'} values={[addressStreet]}
        testDataId={'confirm-content-address-street'}
      />
      <ConfirmContent
        label={'建物・部屋'} values={[addressBuilding ?? '']}
        testDataId={'confirm-content-address-building'}
      />
    </PIMStack>
  )
}
